/* Cart drawer upsells: add an upsell product to the cart from inside the
   drawer and refresh the drawer in place. Delegated + bound once. */
(function () {
  if (window.__cartUpsellsBound) return;
  window.__cartUpsellsBound = true;

  function root() {
    var r = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return r.replace(/\/$/, '');
  }

  document.addEventListener('click', function (e) {
    // Slider arrows
    var arrow = e.target.closest('[data-upsell-prev], [data-upsell-next]');
    if (arrow) {
      var wrap = arrow.closest('.cart-upsells');
      var slider = wrap && wrap.querySelector('[data-upsell-slider]');
      if (slider) {
        var dir = arrow.hasAttribute('data-upsell-next') ? 1 : -1;
        var card = slider.querySelector('.cart-upsell__card');
        var step = card ? card.getBoundingClientRect().width + 8 : slider.clientWidth * 0.85;
        slider.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    var btn = e.target.closest('.cart-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (json) {
        var drawer = document.querySelector('cart-drawer');
        if (json.status) {
          // error (e.g. sold out) — restore the button
          btn.classList.remove('is-loading');
          btn.disabled = false;
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(json);
        } else {
          window.location.href = root() + '/cart';
        }
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  });
})();